import { combineLocationString, splitLocationString } from '../../../util/index';
import { AccessToken } from '../../models/index';
import { UseCase } from '../UseCase';
import { DecodeAccessToken } from './DecodeAccessToken';
import { SetOAuthError } from './SetOAuthError';
import { SetOAuthState } from './SetOAuthState';

export class ParseAccessToken implements UseCase<Location, AccessToken | undefined> {
    private setOAuthState = new SetOAuthState();
    private setOAuthError = new SetOAuthError();
    private decodeAccessToken = new DecodeAccessToken();

    execute(location: Location): AccessToken | undefined {
        if (location.hash || location.search) {
            const map = splitLocationString(location.hash || location.search);
            if (map.access_token || map.error || map.error_description) {
                let access: AccessToken | undefined;
                if (map.access_token) {
                    // TODO: Re-implement in DASH-782
                    // const state = this.getOAuthState.execute();
                    // if (state && map.state !== state) {
                    //   this.setOAuthState.execute(false);
                    //   this.setOAuthError.execute('OAuth state does not match');
                    // } else {
                    access = this.decodeAccessToken.execute(map.access_token);
                    this.setOAuthState.execute(false);
                    this.setOAuthError.execute(undefined);
                    // }
                } else {
                    this.setOAuthError.execute(map.error_description || map.error);
                }

                if (location.hash) {
                    [
                        'access_token',
                        'token_type',
                        'state',
                        'expires_in',
                        'jti',
                        'error',
                        'error_description'
                    ].forEach((remove) => {
                        delete map[remove];
                    });

                    const restore = combineLocationString(map);
                    location.hash = restore ? `#${restore}` : '';
                    window.location.hash = restore ? `#${restore}` : ''; // needed when redirects to some other pages instead of /login - token hash remains in the url
                }

                return access;
            }
        }
    }
}
